import React from "react";
import NextImage from "next/image";
import { useAppDispatch } from "src/hooks";
import { useRouter } from "next/router";

// actions
import { setReviewClinic } from "src/redux/slices/review";

// components
import Button from "src/components/ui/button/button";
import Link from "src/components/ui/Link";
import { EVariants } from "src/constants/variants";
import {
  ContentWrapper,
  RatingInfoWrapper,
  Title,
  Rate,
  Score,
  AmountOfReviews,
  StarsWrapper,
  Star,
} from "./totalRating.styles";

const TotalRatingContainer = ({ reviewsCount, avgRating, clinic }: any) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const sVar = parseInt(reviewsCount) !== 1 ? "s" : "";
  const amountOfReviews = `(${reviewsCount} review${sVar})`;
  const ratingRounded = Array(Math.round(avgRating)).fill(null);

  const leaveReview = () => {
    dispatch(setReviewClinic(clinic));
    router.push({ pathname: "/leave-review", query: { clinic: clinic.id } });
  };

  return (
    <ContentWrapper>
      <RatingInfoWrapper>
        <Title>Total rating</Title>
        <Rate>
          <Score>{avgRating}</Score>
          <AmountOfReviews>{amountOfReviews}</AmountOfReviews>
        </Rate>
        <StarsWrapper>
          {ratingRounded.map((item, index) => (
            <Star key={index}>
              <NextImage src="/icons/star-full-blue.svg" width={26} height={25} />
            </Star>
          ))}
        </StarsWrapper>
      </RatingInfoWrapper>
      <Button variant={EVariants.PRIMARY} style={{ width: "100%" }} onClick={leaveReview}>
        Leave a review
      </Button>
    </ContentWrapper>
  );
};

export default TotalRatingContainer;
